enum ADMIN_PAGE_KEY {}

export default ADMIN_PAGE_KEY;
